module.exports = __webpack_public_path__ + "img/share-tip.ad3cf7fc.png";